import { InjectionToken } from '@angular/core';
import { IDetailMap } from '../interfaces';
export const RECOVERY_PAGE_DETAIL_MAP = new InjectionToken<IDetailMap>('RECOVERY_PAGE_DETAIL_MAP');
